import request from '@/api/request'


export function fetchDetail(data) {
    return request({
        url: `/model-analysis/detection/query/${data.id}/${data.type}`,
    })
}

export function fetchDetailByCode(data) {
    return request({
        url: `/model-analysis/detection/queryByCode/${data.code}/${data.type}`,
    })
}

export function fetchDefectPipeList(data) {
    return request({
        url: '/model-analysis/detection/listDefectPipe',
        method: 'post',
        data,
    })
}

export function fetchDefectTestItemByCode(data) {
    return request({
        url: '/model-analysis/detection/listTestItemByCode',
        method: 'post',
        data,
    })
}